import { render, staticRenderFns } from "./FundHoldings.vue?vue&type=template&id=49b182bc&scoped=true"
import script from "./FundHoldings.vue?vue&type=script&lang=js"
export * from "./FundHoldings.vue?vue&type=script&lang=js"
import style0 from "./FundHoldings.vue?vue&type=style&index=0&id=49b182bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b182bc",
  null
  
)

export default component.exports